import brandLogo from "@/assets/smart-word-labs-logo.png.asset.json";

export const SITE_URL = "https://smartwordlabs.com";

export const SITE_NAME = "Smart Word Labs";

/** Absolute URL of the Smart Word Labs brand logo, for social share previews. */
export const BRAND_OG_IMAGE = `${SITE_URL}${brandLogo.url}`;
export const BRAND_OG_IMAGE_ALT =
  "Smart Word Labs — Creative Language Hub for Kids";

export type Crumb = { name: string; path: string };

/**
 * Builds a schema.org BreadcrumbList JSON-LD script entry for a route's head().
 * Always prepends the Home crumb. Per Google's guidance the final (current)
 * item omits `item`.
 */
export function breadcrumbJsonLd(trail: Crumb[]) {
  const items = [{ name: "Home", path: "/" }, ...trail];
  return {
    type: "application/ld+json",
    children: JSON.stringify({
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: items.map((crumb, index) => {
        const isLast = index === items.length - 1;
        return {
          "@type": "ListItem",
          position: index + 1,
          name: crumb.name,
          ...(isLast
            ? {}
            : { item: crumb.path === "/" ? SITE_URL : `${SITE_URL}${crumb.path}` }),
        };
      }),
    }),
  };
}
